import SearchComponent from "../../components/search-component/SearchComponent";
import details from "../../utils/constants/details.json";
import { useState, useEffect, useContext } from "react";
import CommonContext from "../../utils/contexts/CommonContext";
import useTabTransition from "../../utils/custom-hooks/useTabTransition";
import useDynamicImageGenerate from "../../utils/custom-hooks/useDynamicImageGenerate";

const PostLayout = (props) => {
    const { name, resume } = details;

    const { date, description, subText, points, cards, highlights, image, imageCover, video, hashtag, pin, showMore, link, filter, search } = props;

    const getImages = image && useDynamicImageGenerate(image, false);

    const getCardsImage = imageCover && useDynamicImageGenerate(imageCover, true);

    // for show more option
    const [showLimit, setShowLimit] = useState(0);

    const { theme } = useContext(CommonContext);

    const postLayout = (
        <div className="hide">
            <div className="pt--60">
                <div
                    className={`profile-data ${getCardsImage && "profile-card--image"}`}
                    style={{
                        backgroundColor: theme.styles.cardColor,
                        "--dynamic-bg": getCardsImage ? `url(${getCardsImage})` : "none",
                    }}>
                    <p className="profile-img--fixed"></p>

                    <div className="profile-info--data">
                        <div className="profile-info--fixed">
                            <p className="profile-name--fixed" style={{ color: theme.styles.textColor }}>
                                {name}
                            </p>

                            <p className="profile-date--fixed">{date ? date : "08 Aug 2023"}</p>

                            {pin && <p className="profile-date--fixed">📌 Pinned</p>}
                        </div>

                        <div className="pinned-info">
                            <div>
                                {/* description of the post */}
                                {description && (
                                    <div>
                                        <p className="profile-descriptions" style={{ color: theme.styles.textColor }}>
                                            {description}
                                        </p>
                                    </div>
                                )}

                                {search && (
                                    <div>
                                        <SearchComponent />
                                    </div>
                                )}

                                {/* subtext for the post */}
                                {subText && (
                                    <div>
                                        <div className="profile-experience">
                                            {Object.keys(subText).map((value, index) => {
                                                return (
                                                    <p
                                                        key={index}
                                                        className="profile-section--subText"
                                                        style={index > showLimit ? { display: "none" } : { display: "block" }}>
                                                        {subText[value]}
                                                    </p>
                                                );
                                            })}
                                        </div>

                                        {/* show more button for subtexts with multiple points */}
                                        {showMore && showLimit < Object.keys(subText).length - 1 && (
                                            <div className="show-more--adjust">
                                                <p className="read-more--dots">...</p>
                                                <a
                                                    className="read-more--section"
                                                    style={{ color: theme.styles.accentColor }}
                                                    onClick={() => {
                                                        setShowLimit(showLimit + 1);
                                                    }}>
                                                    Show More
                                                </a>
                                            </div>
                                        )}
                                    </div>
                                )}

                                {/* individual short points */}
                                {points && (
                                    <div className="profile-skill--arrange">
                                        <div className="profile-skill--arrange">
                                            {points.map((data) => {
                                                return (
                                                    <p key={data} className="profile-section--subText">
                                                        {data}
                                                    </p>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}

                                {/* card layout of data with logo, title, link, etc. */}
                                {cards && (
                                    <div className="profile-social--section">
                                        <div className="profile-section--fixed">
                                            {Object.keys(cards).map((data) => {
                                                return (
                                                    <div key={data} className="social-links">
                                                        <a
                                                            href={data === "gmail" ? `mailto:${cards[data]}` : "https://www." + cards[data]}
                                                            target="_blank"
                                                            className="profile-socials"
                                                            style={{ backgroundColor: theme.styles.subCardColor }}>
                                                            <i
                                                                className={
                                                                    data === "gmail"
                                                                        ? `profile-img fa-envelope fa-solid fa-${data}`
                                                                        : `profile-img fa-brands fa-${data}`
                                                                }
                                                                style={{ color: theme.styles.textColor }}></i>
                                                            <p className="profile-descriptions" style={{ color: theme.styles.textColor }}>
                                                                {data}
                                                            </p>
                                                            <p className="profile-social--links">{cards[data]}</p>
                                                        </a>
                                                    </div>
                                                );
                                            })}

                                            {/* for downloading resume */}
                                            <div className="social-links">
                                                <a
                                                    className="profile-socials"
                                                    href={resume}
                                                    target="_blank"
                                                    style={{ backgroundColor: theme.styles.subCardColor }}>
                                                    <p className="profile-descriptions" style={{ color: theme.styles.textColor }}>
                                                        Download Resume
                                                    </p>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* highlighted data */}
                                {highlights && (
                                    <div className="profile-experience pro-exp">
                                        <p className="profile-descriptions" style={{ color: theme.styles.textColor }}>
                                            {highlights.name}
                                        </p>

                                        <div className="experience-card">
                                            <p
                                                className="experience-description profile-section--subText"
                                                style={{ color: theme.styles.subTextColor, backgroundColor: theme.styles.subCardColor }}>
                                                {highlights.role}
                                            </p>
                                            <p
                                                className="experience-description profile-section--subText"
                                                style={{ color: theme.styles.subTextColor, backgroundColor: theme.styles.subCardColor }}>
                                                {highlights.duration}
                                            </p>
                                        </div>
                                    </div>
                                )}

                                {/* images */}
                                {image && getImages && <div className="img-background">{getImages}</div>}

                                {/* videos */}
                                {video && (
                                    <div className="img-background">
                                        <iframe
                                            width="420"
                                            height="315"
                                            src={`https://www.youtube.com/embed/${video}/`}
                                            title="YouTube Video"
                                            frameBorder="0"
                                            allowFullScreen></iframe>
                                    </div>
                                )}

                                {/* external links */}
                                {link && (
                                    <div className="read-more--adjust">
                                        <a
                                            className="read-more--section"
                                            style={{ color: theme.styles.textColor }}
                                            target="_blank"
                                            href={link.feedLink}>
                                            {link.linkText}
                                        </a>
                                    </div>
                                )}

                                {/* filters */}
                                {filter && (
                                    <div className="read-more--adjust">
                                        <a className="read-more--section" style={{ color: theme.styles.textColor }} href={filter.param}>
                                            {filter.title}
                                        </a>
                                    </div>
                                )}

                                {/* hashtag for the posts */}
                                {hashtag && (
                                    <div>
                                        {hashtag.includes("#") ? (
                                            <p className="profile-hashtag" style={{ color: theme.styles.accentColor }}>
                                                {hashtag}
                                            </p>
                                        ) : (
                                            <p className="profile-hashtag" style={{ color: theme.styles.accentColor }}>
                                                {"#" + hashtag}
                                            </p>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    useEffect(() => {
        useTabTransition();
    }, []);

    return postLayout;
};

export default PostLayout;
